import { FieldPosition, TeamFormation } from "@virtualprogaming/js-public-sdk";

export type PositionOffsetFormat = `${number}%`;
export interface FieldPositionConfig {
  position: FieldPosition;
  top: PositionOffsetFormat;
  left: PositionOffsetFormat;
}
export type Formation = Record<number, FieldPositionConfig>;

export const FORMATIONS: Record<TeamFormation, Formation> = {
  [TeamFormation._352]: {
    0: { position: FieldPosition.Gk, left: "50%", top: "90%" },
    1: { position: FieldPosition.Cb, left: "20%", top: "70%" },
    2: { position: FieldPosition.Cb, left: "50%", top: "70%" },
    3: { position: FieldPosition.Cb, left: "80%", top: "70%" },
    4: { position: FieldPosition.Cdm, left: "30%", top: "50%" },
    5: { position: FieldPosition.Cdm, left: "70%", top: "50%" },
    6: { position: FieldPosition.Rm, left: "90%", top: "30%" },
    7: { position: FieldPosition.Lm, left: "10%", top: "30%" },
    8: { position: FieldPosition.Cam, left: "50%", top: "25%" },
    9: { position: FieldPosition.St, left: "30%", top: "5%" },
    10: { position: FieldPosition.St, left: "70%", top: "5%" },
  },
  [TeamFormation._3142]: {
    0: { position: FieldPosition.Gk, left: "50%", top: "90%" },
    1: { position: FieldPosition.Cb, left: "20%", top: "70%" },
    2: { position: FieldPosition.Cb, left: "50%", top: "70%" },
    3: { position: FieldPosition.Cb, left: "80%", top: "70%" },
    4: { position: FieldPosition.Cdm, left: "50%", top: "50%" },
    5: { position: FieldPosition.Rm, left: "90%", top: "30%" },
    6: { position: FieldPosition.Cm, left: "65%", top: "27.5%" },
    7: { position: FieldPosition.Cm, left: "35%", top: "27.5%" },
    8: { position: FieldPosition.Lm, left: "10%", top: "30%" },
    9: { position: FieldPosition.St, left: "30%", top: "5%" },
    10: { position: FieldPosition.St, left: "70%", top: "5%" },
  },
  [TeamFormation._343]: {
    0: { position: FieldPosition.Gk, left: "50%", top: "90%" },
    1: { position: FieldPosition.Cb, left: "20%", top: "70%" },
    2: { position: FieldPosition.Cb, left: "50%", top: "70%" },
    3: { position: FieldPosition.Cb, left: "80%", top: "70%" },
    4: { position: FieldPosition.Lm, left: "10%", top: "35%" },
    5: { position: FieldPosition.Cm, left: "35%", top: "40%" },
    6: { position: FieldPosition.Cm, left: "65%", top: "40%" },
    7: { position: FieldPosition.Rm, left: "90%", top: "35%" },
    8: { position: FieldPosition.Lw, left: "20%", top: "10%" },
    9: { position: FieldPosition.St, left: "50%", top: "5%" },
    10: { position: FieldPosition.Rw, left: "80%", top: "10%" },
  },
  [TeamFormation._3421]: {
    0: { position: FieldPosition.Gk, left: "50%", top: "90%" },
    1: { position: FieldPosition.Cb, left: "20%", top: "70%" },
    2: { position: FieldPosition.Cb, left: "50%", top: "70%" },
    3: { position: FieldPosition.Cb, left: "80%", top: "70%" },
    4: { position: FieldPosition.Lm, left: "10%", top: "35%" },
    5: { position: FieldPosition.Cm, left: "35%", top: "45%" },
    6: { position: FieldPosition.Cm, left: "65%", top: "45%" },
    7: { position: FieldPosition.Rm, left: "90%", top: "35%" },
    8: { position: FieldPosition.Lf, left: "30%", top: "15%" },
    9: { position: FieldPosition.St, left: "50%", top: "10%" },
    10: { position: FieldPosition.Rf, left: "70%", top: "15%" },
  },
  [TeamFormation._433]: {
    0: { position: FieldPosition.Gk, left: "50%", top: "85%" },
    1: { position: FieldPosition.Lb, left: "10%", top: "70%" },
    2: { position: FieldPosition.Cb, left: "35%", top: "75%" },
    3: { position: FieldPosition.Cb, left: "65%", top: "75%" },
    4: { position: FieldPosition.Rb, left: "90%", top: "70%" },
    5: { position: FieldPosition.Cm, left: "25%", top: "40%" },
    6: { position: FieldPosition.Cm, left: "50%", top: "40%" },
    7: { position: FieldPosition.Cm, left: "75%", top: "40%" },
    8: { position: FieldPosition.Lw, left: "15%", top: "10%" },
    9: { position: FieldPosition.St, left: "50%", top: "5%" },
    10: { position: FieldPosition.Rw, left: "85%", top: "10%" },
  },
  [TeamFormation._41212]: {
    0: { position: FieldPosition.Gk, left: "50%", top: "85%" },
    1: { position: FieldPosition.Lb, left: "10%", top: "70%" },
    2: { position: FieldPosition.Cb, left: "35%", top: "75%" },
    3: { position: FieldPosition.Cb, left: "65%", top: "75%" },
    4: { position: FieldPosition.Rb, left: "90%", top: "70%" },
    5: { position: FieldPosition.Cdm, left: "50%", top: "55%" },
    6: { position: FieldPosition.Lm, left: "15%", top: "35%" },
    7: { position: FieldPosition.Rm, left: "85%", top: "35%" },
    8: { position: FieldPosition.Cam, left: "50%", top: "20%" },
    9: { position: FieldPosition.St, left: "25%", top: "5%" },
    10: { position: FieldPosition.St, left: "75%", top: "5%" },
  },
  [TeamFormation._451]: {
    0: { position: FieldPosition.Gk, left: "50%", top: "85%" },
    1: { position: FieldPosition.Lb, left: "10%", top: "70%" },
    2: { position: FieldPosition.Cb, left: "35%", top: "75%" },
    3: { position: FieldPosition.Cb, left: "65%", top: "75%" },
    4: { position: FieldPosition.Rb, left: "90%", top: "70%" },
    5: { position: FieldPosition.Cm, left: "50%", top: "50%" },
    6: { position: FieldPosition.Lm, left: "5%", top: "35%" },
    7: { position: FieldPosition.Cam, left: "25%", top: "25%" },
    8: { position: FieldPosition.Cam, left: "75%", top: "25%" },
    9: { position: FieldPosition.Rm, left: "95%", top: "35%" },
    10: { position: FieldPosition.St, left: "50%", top: "10%" },
  },
  [TeamFormation._4231]: {
    0: { position: FieldPosition.Gk, left: "50%", top: "85%" },
    1: { position: FieldPosition.Lb, left: "10%", top: "70%" },
    2: { position: FieldPosition.Cb, left: "35%", top: "75%" },
    3: { position: FieldPosition.Cb, left: "65%", top: "75%" },
    4: { position: FieldPosition.Rb, left: "90%", top: "70%" },
    5: { position: FieldPosition.Cdm, left: "20%", top: "55%" },
    6: { position: FieldPosition.Cdm, left: "80%", top: "55%" },
    7: { position: FieldPosition.Cam, left: "50%", top: "40%" },
    8: { position: FieldPosition.Cam, left: "25%", top: "20%" },
    9: { position: FieldPosition.Cam, left: "75%", top: "20%" },
    10: { position: FieldPosition.St, left: "50%", top: "5%" },
  },
  [TeamFormation._442]: {
    0: { position: FieldPosition.Gk, left: "50%", top: "85%" },
    1: { position: FieldPosition.Lb, left: "10%", top: "70%" },
    2: { position: FieldPosition.Cb, left: "35%", top: "75%" },
    3: { position: FieldPosition.Cb, left: "65%", top: "75%" },
    4: { position: FieldPosition.Rb, left: "90%", top: "70%" },
    5: { position: FieldPosition.Lm, left: "5%", top: "37.5%" },
    6: { position: FieldPosition.Cm, left: "35%", top: "42.5%" },
    7: { position: FieldPosition.Cm, left: "65%", top: "42.5%" },
    8: { position: FieldPosition.Rm, left: "95%", top: "37.5%" },
    9: { position: FieldPosition.St, left: "35%", top: "10%" },
    10: { position: FieldPosition.St, left: "65%", top: "10%" },
  },
  [TeamFormation._4321]: {
    0: { position: FieldPosition.Gk, left: "50%", top: "85%" },
    1: { position: FieldPosition.Lb, left: "10%", top: "70%" },
    2: { position: FieldPosition.Cb, left: "35%", top: "75%" },
    3: { position: FieldPosition.Cb, left: "65%", top: "75%" },
    4: { position: FieldPosition.Rb, left: "90%", top: "70%" },
    5: { position: FieldPosition.Cm, left: "25%", top: "40%" },
    6: { position: FieldPosition.Cm, left: "50%", top: "40%" },
    7: { position: FieldPosition.Cm, left: "75%", top: "40%" },
    8: { position: FieldPosition.Lf, left: "30%", top: "10%" },
    9: { position: FieldPosition.St, left: "50%", top: "5%" },
    10: { position: FieldPosition.Rf, left: "70%", top: "10%" },
  },
  [TeamFormation._4222]: {
    0: { position: FieldPosition.Gk, left: "50%", top: "85%" },
    1: { position: FieldPosition.Lb, left: "10%", top: "70%" },
    2: { position: FieldPosition.Cb, left: "35%", top: "75%" },
    3: { position: FieldPosition.Cb, left: "65%", top: "75%" },
    4: { position: FieldPosition.Rb, left: "90%", top: "70%" },
    5: { position: FieldPosition.Cdm, left: "40%", top: "50%" },
    6: { position: FieldPosition.Cdm, left: "60%", top: "50%" },
    7: { position: FieldPosition.Cam, left: "20%", top: "30%" },
    8: { position: FieldPosition.Cam, left: "80%", top: "30%" },
    9: { position: FieldPosition.St, left: "30%", top: "5%" },
    10: { position: FieldPosition.St, left: "70%", top: "5%" },
  },
  [TeamFormation._5212]: {
    0: { position: FieldPosition.Gk, left: "50%", top: "85%" },
    1: { position: FieldPosition.Lb, left: "5%", top: "70%" },
    2: { position: FieldPosition.Cb, left: "25%", top: "75%" },
    3: { position: FieldPosition.Cb, left: "50%", top: "75%" },
    4: { position: FieldPosition.Cb, left: "75%", top: "75%" },
    5: { position: FieldPosition.Rb, left: "95%", top: "70%" },
    6: { position: FieldPosition.Cm, left: "25%", top: "50%" },
    7: { position: FieldPosition.Cm, left: "75%", top: "50%" },
    8: { position: FieldPosition.Cam, left: "50%", top: "30%" },
    9: { position: FieldPosition.St, left: "30%", top: "5%" },
    10: { position: FieldPosition.St, left: "70%", top: "5%" },
  },
  [TeamFormation._532]: {
    0: { position: FieldPosition.Gk, left: "50%", top: "85%" },
    1: { position: FieldPosition.Lb, left: "5%", top: "70%" },
    2: { position: FieldPosition.Cb, left: "25%", top: "75%" },
    3: { position: FieldPosition.Cb, left: "50%", top: "75%" },
    4: { position: FieldPosition.Cb, left: "75%", top: "75%" },
    5: { position: FieldPosition.Rb, left: "95%", top: "70%" },
    6: { position: FieldPosition.Cm, left: "25%", top: "40%" },
    7: { position: FieldPosition.Cm, left: "50%", top: "40%" },
    8: { position: FieldPosition.Cm, left: "75%", top: "40%" },
    9: { position: FieldPosition.St, left: "35%", top: "5%" },
    10: { position: FieldPosition.St, left: "65%", top: "5%" },
  },
};
